import { Component, OnInit, Inject, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InterfaceArea } from 'app/models/area.model';
import { InterfaceEmployee } from 'app/models/employee.model';
import { DepartmentService } from 'app/services/department.service';
import { EmployeeService } from 'app/services/employee.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { timezone } from 'assets/constants/timezone';
import { InterfaceDepartment } from 'app/models/department.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

@Component({
  selector: 'app-add-area',
  templateUrl: './add-area.component.html',
  styleUrls: ['./add-area.component.scss']
})
export class AddAreaComponent implements OnInit, OnDestroy {

  areaForm: FormGroup;
  userId: string;
  userName: string;
  isSaving = false;
  employees: InterfaceEmployee[] = [];
  subscriptions: Subscription[] = [];
  selectedEmployee: InterfaceEmployee = {};
  @Input() department: InterfaceDepartment;

  constructor(
    private fb: FormBuilder,
    protected departmentService: DepartmentService,
    protected employeeService: EmployeeService,
    public ngbActiveModal: NgbActiveModal
  ) {
    this.areaForm = this.fb.group({
      name: [null, Validators.required],
      description: [null, Validators.required]
    });
    this.userId = localStorage.getItem("userId") || "Not found User";
    this.userName = localStorage.getItem("userName") || "Not found User";
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  getEmployees(): void {
    this.employeeService.getEmployees(true, ["manager", "director", "admin"]).pipe(take(1)).subscribe((result: InterfaceEmployee[]) => {
      this.employees = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  searchEmployee(name: string): void {
    this.employeeService.searchEmployee(name, false).pipe(take(1)).subscribe((result: InterfaceEmployee[]) => {
      this.employees = [];
      this.employees = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  close(): void {
    this.ngbActiveModal.close();
  }

  save(): void {
    this.isSaving = true;
    const newArea: InterfaceArea = {
      ...this.areaForm.value,
      id: this.departmentService.generateId(),
      createdByName: this.userName,
      createdById: this.userId,
      createdAt: dayjs().tz(timezone).unix(),
      departmentId: this.department.id,
      departmentName: this.department.name,
      indicators: []
    };
    newArea.updatedById = this.userId;
    newArea.updatedByName = this.userName;
    newArea.updatedAt = dayjs().tz(timezone).unix();
    this.departmentService.createArea(newArea).then((result: any) => {
      this.ngbActiveModal.close({
        result,
        success: true
      });
    }).catch((error: any) => {
      console.error("Error update department =>", error);
      this.ngbActiveModal.close({
        error,
        success: false
      });
    });
  }

}
